
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
 name:"icbc",
 components: {
   CommonTitle,
   BannerTop,
   // Notice
 },
 data() {
    return {
      bannerUrl:require("~/static/images/news/banner.png"),
      imgUrl:require(`@/static/images/news/icbc/1.png`),
    }
  },
  computed: {
    contentList () {
      return this.$t('news.icbc.contentList')
    },
  },
}
